import React from 'react';
import { Col, Pager, Label } from 'react-bootstrap';
//import { ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';

const OrdersPager = ({page, pages, handleChangePage}) => (  
  <Col xs={12}>
    <Pager className="pagerMargin">      
      <Pager.Item previous onClick={() => handleChangePage(page-1)}
        href={"#"+(page-1)} disabled={page==1}>
        &larr; Precedente
      </Pager.Item>     
      
      <Label bsStyle="primary">Pagina {page} di {pages}</Label>      
      
      <Pager.Item next onClick={() => handleChangePage(page+1)}
        href={"#"+(page+1)} disabled={page==pages}>
        Successivo &rarr;
      </Pager.Item>
    </Pager>
  </Col>    
);

export default OrdersPager;


// WEBPACK FOOTER //
// ./src/cmp/Summary/OrdersPager.js